import { Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SFRSendEmailManagerService {
    constructor(public http: HttpClient) { }

    /*
{
          params: new HttpParams()
            .set('id-execution', idExecution),
        }
*/

  async sendCREATENotificationToClient(mail:string, execution_link:string): Promise<any> {
      return this.http.post<any>(`${environment.apiUrl}/SFR/sendMailToClient`,
          { email: mail, execution_link: execution_link}
      ).toPromise();
  }

    async isThisExecutionInSafeMode(idexec) {
        return this.http.post<any>(`${environment.apiUrl}/SFR/isThisExecutionInSafeMode`,
            { email: '', execution_link: idexec }
        ).toPromise();
    }
    async makeThisExecutionPublic(idexec) {
        return this.http.post<any>(`${environment.apiUrl}/SFR/makeThisExecutionPublic`,
            { email: '', execution_link: idexec }
        ).toPromise();
    }


    async getCustomClientDataTemplate(data) {
        return this.http.post<any>(`${environment.apiUrl}/SFR/retrieveInputTemplateForSFR`,data).toPromise();   
    }

    async sendMailToOperator(idexecution:string) {
        return this.http.post<any>(`${environment.apiUrl}/SFR/sendMailToOperator`, { id: idexecution }).toPromise();   
    }
    async getIfClientDataWereUploaded(idexecution:string) {
        return this.http.get<any>(`${environment.apiUrl}/SFR/getCurrentlyUploadedClientFiles`, {
            params: new HttpParams().set('id-execution', idexecution)
        }).toPromise();   
    }
    
}
